'use es6';

import { OrderedMap } from 'immutable';
import { addCondition, makeLogicGroup } from './LogicGroup';
const Restricted = makeLogicGroup('Restricted', OrderedMap());
addCondition.implement(Restricted, (_, group) => group);
export default Restricted;